import React from "react";
import PropTypes from "prop-types";

import { BuildEffects } from "@components/transition";
import Rule from "@components/Rule";
import SideNote from "@components/SideNote";
import { InlineVideo } from "@components/Video";

import { css } from "@oddcommon/utils";
import styles from "./HeroSection.module.scss";

export default function HeroSection({
  title,
  client,
  description,
  ruleLabel,
  hero,

  children,
  className,
  awards,
  ...props
}) {
  return (
    <section className={css(styles.base, className)} {...props}>
      <header>
        {ruleLabel && (
          <BuildEffects.RuleWipe className={styles.rule}>
            <Rule>{ruleLabel}</Rule>
          </BuildEffects.RuleWipe>
        )}
        <div className={styles.left}>
          <h1>
            <BuildEffects.TextMask>{title}</BuildEffects.TextMask>
          </h1>
          {client && (
            <BuildEffects.FadeUp className={styles.client}>
              <p className={styles.label}>Client</p>
              <p>{client}</p>
            </BuildEffects.FadeUp>
          )}
        </div>
        <BuildEffects.FadeUp className={styles.right}>{description}</BuildEffects.FadeUp>
        <BuildEffects.FadeUp className={styles.sideNoteContainer}>
          <SideNote>{title}</SideNote>
        </BuildEffects.FadeUp>
      </header>
      {hero?.content.src && hero?.type && (
        <BuildEffects.FadeUp className={styles.heroGrid}>
          <div className={styles.heroContainer}>
            {hero.type === "image" && (
              <img src={hero.content.src + "?fm=webp&w=1920&q=80"} alt={hero.content.alt} />
            )}
            {hero.type === "video" && (
              <InlineVideo
                src={hero.content.src}
                poster={hero.content.poster}
                vimeoId={hero.content.vimeoId}
                awards={awards}
              />
            )}
          </div>
        </BuildEffects.FadeUp>
      )}
      {children}
    </section>
  );
}

HeroSection.propTypes = {
  ruleLabel: PropTypes.node,
  title: PropTypes.node.isRequired,
  description: PropTypes.oneOfType([PropTypes.element, PropTypes.arrayOf(PropTypes.element)]),
  client: PropTypes.string,
  hero: PropTypes.shape({
    content: PropTypes.shape({
      src: PropTypes.string.isRequired,
      alt: PropTypes.string,
      poster: PropTypes.string,
      vimeoId: PropTypes.number,
    }),
    type: PropTypes.oneOf(["image", "video"]).isRequired,
  }),

  children: PropTypes.node,
  className: PropTypes.string,
};
